import type { ButtonHTMLAttributes, ReactNode } from "react";
import { useCanManageCertificaciones } from "../permissions/useCertificationPermissions";

export type CertificationButtonVariant = "primary" | "secondary" | "danger" | "ghost";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: CertificationButtonVariant;
  icon?: ReactNode;
  requiresManage?: boolean;
};

export function CertificationButton({
  variant = "secondary",
  icon,
  requiresManage = false,
  className = "",
  children,
  type = "button",
  ...props
}: Props) {
  const canManage = useCanManageCertificaciones();

  if (requiresManage && !canManage) {
    return null;
  }

  return (
    <button
      type={type}
      className={`iso27001-button iso27001-button-${variant} ${className}`.trim()}
      {...props}
    >
      {icon}
      <span>{children}</span>
    </button>
  );
}
